export const API_URL = `${process.env.NEXT_PUBLIC_BACKEND_HOST}/biz/api/v1`
